import tabs from "./modules/tabs";
import slider from "./modules/slider";
import quiz from "./modules/quiz";
import linearAnimations from "./modules/linearAnimations";
import send from "./modules/send";
import validate from "./modules/validate";
"use strict";

window.addEventListener("load", () => {
  gsap.to('.preloader', {
    duration: 1,
    autoAlpha: 0,
    onComplete: () => {
    }
  })
  tabs();
  slider();
  quiz();
 
  gsap.to(".projects__descr span", {
      scrollTrigger: {
        trigger: '.projects__descr',
        start: 'top 90%',
        end: 'bottom 50%',
        scrub: 2
      },
      ease: "power1.out",
      backgroundPositionX: '-100%'
    })
  gsap.to(".about__descr span", {
      scrollTrigger: {
        trigger: '.about__descr',
        start: 'top 90%',
        end: 'bottom 50%',
        scrub: 2
      },
      ease: "power1.out",
      backgroundPositionX: '-100%'
    })

    gsap.to('.preloader', {
      duration: 1,
      autoAlpha: 0,
      onComplete: () => {
        
      }
    })

    const tlNumbers = gsap.timeline({
      scrollTrigger: {
        trigger: ".numbers",
        start: "top 30%",
        toggleActions: "play none none reverse",
      },
      defaults: {
        stagger: .5,
        duration: 1,
      }
    });

    tlNumbers.from(".numbers__item:first-child>span", {textContent: 0, snap: {textContent: 1}})
              .from(".num--num1", {width: 0, height: 0, opacity: 0}, "<0%")
              .to(".numbers__item:first-child>p", {color: '#B4141E'}, "<0%")
              .from(".numbers__item:nth-child(2)>span", {textContent: 0, snap: {textContent: 1}}, "<100%")
              .from(".num--num2", {width: 0, height: 0, opacity: 0}, "<0%")
              .from(".numbers__item:nth-child(3)>span", {textContent: 0 +'%', snap: {textContent: 1}}, "<100%")
              .from(".num--num3", {width: 0, height: 0, opacity: 0}, "<0%")
              .from(".numbers__item:nth-child(3)>div:first-child", {width: 0}, "<0%")
              .from(".numbers__item:nth-child(4)>span>b", {textContent: 0, snap: {textContent: 1}}, "<100%")
              .from(".num--num4", {width: 0, height: 0, opacity: 0}, "<0%")
              .from(".num--num5", {width: 0, height: 0, opacity: 0}, "<20%")
              .from(".num--num6", {width: 0, height: 0, opacity: 0}, "<20%");
             


    linearAnimations();

    validate('input[name="name"]', 'input[name="phone"]', 'input[name="email"]');
    send('#form', 'input[name="name"]', 'input[name="phone"]', 'input[name="email"]', "/mailer/mail-footer.php");
});